<template>
  <div>
    <vue-apex-charts
      class="d-flex justify-content-center"
      type="radialBar"
      v-bind="$attrs"
      height="310"
      :options="chartOptions"
      :series="series"
    />
    <div>
      <b-row>
        <b-col>
          <h5 class="text-info">اتمام بيانات المنظمة</h5>
        </b-col>
        <b-col cols="5">
          <h4 class="text-info">%{{ series[0] }}</h4>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <h5 class="text-success">المعلومات الإلزامية</h5>
        </b-col>
        <b-col cols="5">
          <h4 class="text-success">%{{ series[1] }}</h4>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { BRow, BCol, BButton } from "bootstrap-vue";
export default {
  components: {
    VueApexCharts,
    BRow,
    BCol,
    BButton,
  },
  props: {
    requiredBar: {
      type: Number,
      default: () => 0,
    },
    profileCompletnessBar: {
      type: Number,
      default: () => 0,
    },
  },
  data() {
    return {
      series: [this.profileCompletnessBar, this.requiredBar],
      chartOptions: {
        chart: {
          type: "radialBar",
        },
        fill: {
          colors: ["#4fc98c", "#28c76f"],
        },
        plotOptions: {
          radialBar: {
            dataLabels: {
              total: {
                show: true,
                label: "اكتمال الملف",
                formatter: (x) => "",
              },
            },
          },
        },
        labels: ["اتمام بيانات المنظمة", "المعلومات الإلزامية"],
      },
    };
  },
};
</script>

<style>
.apexcharts-datalabel-label,
.apexcharts-datalabel-value {
  -webkit-font-family: "Cairo", sans-serif !important;
  -o-font-family: "Cairo", sans-serif !important;
  font-family: "Cairo", sans-serif !important;
  color: var(--secondary) !important;
}
.apexcharts-datalabel-label {
  font-size: 10pt;
}
.apexcharts-datalabel-value {
  font-size: 16pt;
}
</style>
